import { Team } from "models/teams/Team";
import React, { useEffect, useState } from "react";
import { ApiService } from "services/ApiService";
import TeamInvites from "./TeamInvites";
import TeamReviewSettingsComponent from "./reviewSettings/TeamReviewSettingsComponent";


export interface TeamsOrganizerProps {
    teamId: string;
}

const TeamsOrganizer : React.FC<TeamsOrganizerProps> = (teamId) => {

    const [team, setTeam] = useState<Team | null>(null);
    const [error, setError] = useState<string | null>(null);
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const response = await ApiService.getTeamAsync(teamId.teamId, '');
                if (!response || !response.data || !response.data.teamId) {
                    setError("No team found for this ID.");
                    return;
                }
                console.log("Fetched team data:", response.data);
                setTeam(response.data);
            } catch (error) {
                setError("Failed to fetch team data.");
                console.error("Fetch error:", error);
            }
        }
        fetchTeam();
    }, [teamId.teamId]);

    if (!teamId || !teamId.teamId) {
        return <div className="text-red-500">Team ID is required.</div>;
    }

    function handleRemoveTeammate(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        const teammateId = event.currentTarget.getAttribute("data-teammate-id");
        console.log("Removing teammate with ID:", teammateId);
        if (!teammateId || !team) return;

        ApiService.RemoveTeamMember(team.teamId, teammateId)
            .then(() => {
                setTeam({
                    ...team,
                    teammates: team.teammates.filter(t => t.id !== teammateId)
                });
            })
            .catch(() => {
                setError("Failed to remove teammate.");
            });
    }

    return (
        <div className="p-4 flex flex-col md:flex-row gap-8">
            <div className="flex-1">
            {error && <div className="text-red-500">{error}</div>}
            {team ? (
                <div>
                <h2 className="text-xl font-bold mb-4">{team.teamName}</h2>
                <ul className="list-disc pl-5">
                    {team.teammates.map((teammate, index) => (
                        <li key={teammate.id} className="mb-2 flex items-center">
                            {`${teammate.firstName} ${teammate.lastName}`}
                                <button
                                    data-teammate-id={teammate.id}
                                    className={`ml-4 px-2 py-1 rounded ${
                                        teammate.id === team.artistId
                                            ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                                            : "bg-red-500 text-white hover:bg-red-600"
                                    }`}
                                    onClick={handleRemoveTeammate}
                                    disabled={teammate.id === team.artistId}
                                >
                                    Remove Team Member 
                                </button>
                        </li>
                    ))}
                </ul>
                </div>
            ) : (
                <div>Loading team data...</div>
            )}
            </div>
            <div className="flex-1">
            <TeamInvites teamId={teamId.teamId} />
            </div>
            <div className="flex-1">
                <TeamReviewSettingsComponent
                    teamId={teamId.teamId}
                    memberNames={team ? team.teammates : []}
                />
            </div>
        </div>
    )
}

export default TeamsOrganizer;